import { orderStatusValueToLabel } from '@/constants/statuses'
import { Chip } from '@mui/material'

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  'wc-pending': { bg: '#FFF3E0', text: '#E65100' },
  'wc-processing': { bg: '#E3F2FD', text: '#1565C0' },
  'wc-public-processing': { bg: '#E0F7FA', text: '#006064' },
  'wc-on-hold': { bg: '#FFF8E1', text: '#F57F17' },
  'wc-clinical-bypass': { bg: '#E0F2F1', text: '#00695C' },
  'wc-awaiting-decision': { bg: '#EDE7F6', text: '#4527A0' },
  'wc-ready-for-fulfillment': { bg: '#E0F7FA', text: '#00838F' },
  'wc-pharmacist-check': { bg: '#F3E5F5', text: '#7B1FA2' },
  'wc-stock-issues': { bg: '#FBE9E7', text: '#BF360C' },
  'wc-picked': { bg: '#E1F5FE', text: '#0277BD' },
  'wc-pharmacist-returned-for-additional-check': { bg: '#FCE4EC', text: '#AD1457' },
  'wc-dispensed': { bg: '#E8F5E9', text: '#2E7D32' },
  'wc-packed': { bg: '#E8EAF6', text: '#283593' },
  'wc-dispatched': { bg: '#E3F2FD', text: '#0D47A1' },
  'wc-delivered': { bg: '#E8F5E9', text: '#1B5E20' },
  'wc-inv-waiting': { bg: '#FFF8E1', text: '#FF8F00' },
  'wc-completed': { bg: '#C8E6C9', text: '#1B5E20' },
  'wc-returned': { bg: '#ECEFF1', text: '#455A64' },
  'wc-cancelled': { bg: '#FFEBEE', text: '#C62828' },
  'wc-refunded': { bg: '#FFCDD2', text: '#B71C1C' },
  // Subscription-specific
  'wc-active': { bg: '#E8F5E9', text: '#2E7D32' },
  'wc-pending-cancel': { bg: '#FFF3E0', text: '#BF360C' },
  'wc-expired': { bg: '#EFEBE9', text: '#4E342E' },
  'wc-switched': { bg: '#E8EAF6', text: '#1A237E' }
}

const DEFAULT_COLOR = { bg: '#F3F4F6', text: '#374151' }

export default function OrderStatusBadge({ status }: { status: string }) {
  const label = orderStatusValueToLabel(status)
  const color = STATUS_COLORS[status] ?? DEFAULT_COLOR

  return (
    <Chip
      label={label}
      size='small'
      sx={{
        backgroundColor: color.bg,
        color: color.text,
        fontWeight: 600,
        fontSize: '12px',
        borderRadius: '6px'
      }}
    />
  )
}
